import React, { type ReactNode } from "react";
import {
	LegacyLogbookRedirect,
	LogbookPage,
	routeLogbook,
} from "./LogbookPage";

export const logbookRoutesMESF: {
	path: string;
	element: ReactNode;
	permission?: string;
}[] = [
	{
		path: routeLogbook,
		element: React.createElement(LogbookPage),
	},
	// Entry and Report were merged into /logbook; keep their old addresses working
	{
		path: "/logbook/entry",
		element: React.createElement(LegacyLogbookRedirect, { mode: "shift" }),
	},
	{
		path: "/logbook/entry/:shiftId",
		element: React.createElement(LegacyLogbookRedirect, { mode: "shift" }),
	},
	{
		path: "/logbook/report",
		element: React.createElement(LegacyLogbookRedirect, { mode: "period" }),
	},
];

export const logbookNavbar = [
	{
		id: "logbook",
		label: "Logbook",
		items: [
			{
				label: "Logbook",
				to: routeLogbook,
			},
		],
	},
];
